import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
declare global {
  interface Window {
    hj: any;
  }
}
@Injectable({
  providedIn: 'root'
})
export class HotjarService {
  private scriptLoaded = false;
  private count:number = 0
  constructor() {
    // this.loadHotjar();
  }

  loadHotjar() {
    if (!environment.hotjarSiteId) {
      console.warn('Hotjar Site ID is not defined in the environment file.');
      return;
    }
    if (this.scriptLoaded) return;
    const script = document.createElement('script');
    script.innerHTML = `
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${environment.hotjarSiteId},hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `;
    document.head.appendChild(script);
    this.scriptLoaded = true;
  }

  identify(userId: string, attributes: { [key: string]: any } = {}) {
    if (typeof window.hj === 'function') {
      window.hj('identify', userId, attributes);
    } else {
      this.count++
      console.warn('Hotjar is not loaded yet. Retrying in 1 second...');
      if(this.count > 3) return;
      setTimeout(() => this.identify(userId, attributes), 1000); // retry once
    }
  }
}